// Import Foundation libraries
import { Foundation } from 'foundation-sites/js/foundation.core';
import { Keyboard } from 'foundation-sites/js/foundation.util.keyboard';
import { MediaQuery } from 'foundation-sites/js/foundation.util.mediaQuery';
// import { Box } from 'foundation-sites/js/foundation.util.box';
// import { onImagesLoaded } from 'foundation-sites/js/foundation.util.imageLoader';
// import { Motion, Move } from 'foundation-sites/js/foundation.util.motion';
// import { Nest } from 'foundation-sites/js/foundation.util.nest';
// import { Timer } from 'foundation-sites/js/foundation.util.timer';

// Import initialization method from shared module
import { init, initPlacesAutocomplete } from './modules/_shared.js';
import { componentTracking, linkTracking } from './modules/_gtmTracking.js';
import { zipCheck } from './modules/_zipCheck';
import { reviews } from './modules/_reviews';
import { providers } from './modules/_providers';
import { gfCustomSpinner } from './modules/_gravityForms';
import { partners } from './modules/_partners';
import { zipLookup } from './modules/_zip-lookup';
import { init as providerV2 } from './modules/_provider-card-v2';
import { providerCard } from './modules/_provider-card';
import { providerZipChecker } from './modules/_provider-zip-checker';
import { state2023 } from './modules/_state2023';
import { subnav } from './modules/_subnav';

// Expose Foundation to jQuery scope
Foundation.addToJquery($);

// Add imported components to Foundation namespace for compatibility
Foundation.Keyboard = Keyboard;
Foundation.MediaQuery = MediaQuery;
// Foundation.Box = Box;
// Foundation.onImagesLoaded = onImagesLoaded;
// Foundation.Motion = Motion;
// Foundation.Move = Move;
// Foundation.Nest = Nest;
// Foundation.Timer = Timer;

import { Touch } from 'foundation-sites/js/foundation.util.touch';
Touch.init($);

import { Triggers } from 'foundation-sites/js/foundation.util.triggers';
Triggers.init($, Foundation);

import { Abide } from 'foundation-sites/js/foundation.abide';
Foundation.plugin(Abide, 'Abide');

// import { Accordion } from 'foundation-sites/js/foundation.accordion';
// Foundation.plugin(Accordion, 'Accordion');

// import { AccordionMenu } from 'foundation-sites/js/foundation.accordionMenu';
// Foundation.plugin(AccordionMenu, 'AccordionMenu');

// import { Drilldown } from 'foundation-sites/js/foundation.drilldown';
// Foundation.plugin(Drilldown, 'Drilldown');

// import { Dropdown } from 'foundation-sites/js/foundation.dropdown';
// Foundation.plugin(Dropdown, 'Dropdown');

// import { DropdownMenu } from 'foundation-sites/js/foundation.dropdownMenu';
// Foundation.plugin(DropdownMenu, 'DropdownMenu');

// import { Equalizer } from 'foundation-sites/js/foundation.equalizer';
// Foundation.plugin(Equalizer, 'Equalizer');

// import { Interchange } from 'foundation-sites/js/foundation.interchange';
// Foundation.plugin(Interchange, 'Interchange');

// import { Magellan } from 'foundation-sites/js/foundation.magellan';
// Foundation.plugin(Magellan, 'Magellan');

// import { OffCanvas } from 'foundation-sites/js/foundation.offcanvas';
// Foundation.plugin(OffCanvas, 'OffCanvas');

// import { ResponsiveMenu } from 'foundation-sites/js/foundation.responsiveMenu';
// Foundation.plugin(ResponsiveMenu, 'ResponsiveMenu');

// import { ResponsiveToggle } from 'foundation-sites/js/foundation.responsiveToggle';
// Foundation.plugin(ResponsiveToggle, 'ResponsiveToggle');

// import { Reveal } from 'foundation-sites/js/foundation.reveal';
// Foundation.plugin(Reveal, 'Reveal');

// import { Slider } from 'foundation-sites/js/foundation.slider';
// Foundation.plugin(Slider, 'Slider');

// import { SmoothScroll } from 'foundation-sites/js/foundation.smoothScroll';
// Foundation.plugin(SmoothScroll, 'SmoothScroll');

// import { Sticky } from 'foundation-sites/js/foundation.sticky';
// Foundation.plugin(Sticky, 'Sticky');

import { Tabs } from 'foundation-sites/js/foundation.tabs';
Foundation.plugin(Tabs, 'Tabs');

// import { Toggler } from 'foundation-sites/js/foundation.toggler';
// Foundation.plugin(Toggler, 'Toggler');

import { Tooltip } from 'foundation-sites/js/foundation.tooltip';
Foundation.plugin(Tooltip, 'Tooltip');

import Bifrost from '../../../bifrost/assets/js/dist/bifrost';

// import { ResponsiveAccordionTabs } from 'foundation-sites/js/foundation.responsiveAccordionTabs';
// Foundation.plugin(ResponsiveAccordionTabs, 'ResponsiveAccordionTabs');

// lazysizes config object must be declared before script initialization
window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.loadMode = 1;
window.lazySizesConfig.expand = 200;

// import js libraries
import 'lazysizes/lazysizes.min';
import 'jquery-validation/dist/jquery.validate.min';
import 'jquery-validation/dist/additional-methods';
import 'jquery-mask-plugin/dist/jquery.mask';
import 'core-js/stable';

if (typeof jsInclude !== 'undefined') {
    require(`./modules/_${jsInclude}`).init(); // eslint-disable-line global-require, no-undef
}

// polyfill code

(function () {}).call(
    (typeof window === 'object' && window) ||
        (typeof self === 'object' && self) ||
        (typeof global === 'object' && global) ||
        {}
);

import './modules/_slick';

window.initPlacesAutocomplete = initPlacesAutocomplete;

// On DOM load
$(document).ready(() => {
    // Initialize Foundation
    init();
    zipCheck();
    gfCustomSpinner();
    componentTracking();
    linkTracking();
    reviews();
    providers();
    state2023();
    partners();
    zipLookup();
    providerV2();
    providerCard();
    providerZipChecker();
    subnav();

    // choose which bifrost functions to load
    const bfrstSettings = {
        functions: {
            ctam: true,
            bannerads: true,
        },
    };
    const bfrst = new Bifrost(bfrstSettings);
    bfrst.init();
});
